import { render, staticRenderFns } from "./SurveyComponent.vue?vue&type=template&id=eb8c635e"
import script from "./SurveyComponent.vue?vue&type=script&lang=ts"
export * from "./SurveyComponent.vue?vue&type=script&lang=ts"
import style0 from "./SurveyComponent.vue?vue&type=style&index=0&id=eb8c635e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports